import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  /* fahuo  */
  deliveryList: "/xxy/warehouse/delivery/list", //发货管理获取列表
  saveDelivery: "/xxy/warehouse/delivery/save", //发货管理获取列表
  updateDelivery: "/xxy/warehouse/delivery/update", //发货管理获取列表
  removeDelivery: "/xxy/warehouse/delivery/remove", //发货管理获取列表

  /* 库存历史 */
  warehouseList: "/xxy/warehouse/stock/list", //仓库管理获取仓库列表
  allWarehouse: "/xxy/basic/warehouse/getInfo", //所有仓库的获取
  stockHistoryList: "/xxy/warehouse/stockHis/list", //仓库历史列表

  outInStock: "/xxy/warehouse/stock/save", //出入库
  bomList: "/xxy/warehouse/stock/getMaterialInfo", //仓库内物料信息
  materialInfo: "/xxy/basic/material/getInfo", //所有物料信息
  listByCompentCode: "/xxy/warehouse/stockOccupy/listByCompentCode",

  /* 流转库存 */
  getComponentIdList: "/xxy/basic/material/getInfo",
  getDetailByComponent: "/xxy/warehouse/circulation/list",
  getChildComponent: "/xxy/basic/bom/listAll",
  getProcedure: "/xxy/basic/procedure/listAll",
  saveLogisticManage: "/xxy/warehouse/stockProcedure/save",
  saveLogisticModify: "/xxy/ss"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}

/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
